import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DisplayCoupon } from './coupon/DisplayCoupon';
import { InputCoupon } from './coupon/InputCoupon';
import { usePromotionStore } from '@store/promotionStore';
import { usePolicyStore } from '@store/policyStore';
import CountdownTimer from '@modals/modalpromotions/components/CountdownTimer';
import { useGetQuotePayment } from '@store/QuoteData';
import * as _ from 'lodash';
import { error } from 'console';

const validCoupons = [
  { name: 'INTERCHYECOCHALL21', value: '20' },
  { name: 'INTERCUPON', value: '10' },
  { name: 'INTERCUPONVALI2', value: '10' },
];

interface CouponI {
  setCouponStart: any;
}

export const Coupon = ({ setCouponStart }: CouponI) => {
  const { breakpoints } = useTheme();
  const isTablet = useMediaQuery(breakpoints.down('md'));
  const { infoPromotion } = usePromotionStore();
  const { policy, addPolicyInfo } = usePolicyStore();

  const { Packages, payment_option } = useGetQuotePayment();

  const [visibleTimer, setVisbleTimer] = useState(false);

  const [coupon, setCoupon] = useState('');
  const [couponError, setCouponError] = useState('');
  const [Discount, setDiscount] = useState({
    name: '',
    value: '',
  });

  const cost = 12163;

  useEffect(() => {
    if (Packages.value !== 'AMP' || payment_option.value !== 'A') {
      setVisbleTimer(false);
      setCoupon('');
    } else {
      setCoupon(policy.codeCoupon.code);
      if (policy.codeCoupon.code) {
        setVisbleTimer(true);
      }
    }
  }, [Packages, payment_option]);

  useEffect(() => {
    if (coupon.length === 0) {
      setVisbleTimer(false);
    }
  }, [coupon]);

  const handleChangeSearch = (text: string) => {
    debounceSearch(text);
  };

  const debounceSearch = useCallback(
    _.debounce(async (_searchVal: string) => {
      await search(_searchVal);
    }, 1000),
    []
  );
  const search = async (text: string) => {
    try {
      setCouponStart(text);
      policy.code = text;
      setCouponError('');
      addPolicyInfo({ ...policy });
      if (Packages.value !== 'AMP' || payment_option.value !== 'A') {
        if (text === policy.codeCoupon.code) {
          setCoupon('');
          policy.code = '';
          addPolicyInfo({ ...policy });
          setCouponError(
            'La forma de pago y/o cobertura seleccionadas no son elegibles para el certificado de regalo '
          );
        }
      } else {
        if (text === policy.codeCoupon.code) {
          setCoupon(policy.codeCoupon.code);
          policy.code = text;
          setCouponError('');
          addPolicyInfo({ ...policy });
          setVisbleTimer(true);
        }
      }
    } catch (error) {
      console.log('Error', error);
    }
  };

  useEffect(() => {
    handleChangeSearch(coupon);
  }, [coupon]);

  useEffect(() => {
    if (policy.codeCoupon.code) {
      setCoupon(policy.codeCoupon.code);
    }
  }, [policy.codeCoupon.code]);

  useEffect(() => {
    if (coupon === '') {
      setCouponError('');
      setDiscount({
        name: '',
        value: '',
      });
      return;
    }

    if (validCoupons.find((c) => c.name === coupon)) {
      setCouponError('');
      setDiscount({
        name: coupon,
        //hacer dinamico el valor del descuento
        value: '10',
      });
    }
  }, [coupon]);

  useEffect(() => {
    if (Packages.value !== 'AMP' || payment_option.value !== 'A') {
      if (coupon === policy.codeCoupon.code) {
        setCouponError(
          'La forma de pago y/o cobertura seleccionadas no son elegibles para el certificado de regalo'
        );
        // setShowToast(true);
        // setShowWarningToast(true);
        // setMessageToast('');
        // setMessageToast(
        //   'La forma de pago y/o cobertura seleccionadas no son elegibles para el certificado de Amazon\n'
        // );
      }
    }
  }, [Packages, payment_option, coupon]);

  return (
    <>
      <Box display="flex" justifyContent="flex-start" margin="0px 0px 15px">
        <Typography
          variant="subtitle1"
          style={{ fontWeight: 'bold', color: '#424242' }}
          textAlign="start"
          fontSize={isTablet ? 15 : 16}
        >
          Cupones
        </Typography>
      </Box>
      <InputCoupon
        isTablet={isTablet}
        coupon={coupon}
        couponError={couponError}
        setCoupon={setCoupon}
        discount={Discount}
      />

      {policy.endDateTime !== '' &&
        visibleTimer &&
        policy.codeCoupon.code !== '' && (
          <div style={{ marginTop: 5 }}>
            <CountdownTimer endDateTime={policy.endDateTime} />
          </div>
        )}

      {Discount.name !== '' && couponError.length < 1 ? (
        <DisplayCoupon Discount={Discount} cost={cost} />
      ) : null}
    </>
  );
};
